"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteThemeDefinition = void 0;
const services_definitions_1 = require("@wix/services-definitions");
exports.SiteThemeDefinition = (0, services_definitions_1.defineService)('viewer-core/viewer-service-site-theme');
//# sourceMappingURL=index.js.map